import React from "react";

const ChevronLeftSmallIcon: React.FC = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.736 17.7364C15.0875 17.3849 15.0875 16.8151 14.736 16.4636L10.2724 12L14.736 7.53639C15.0875 7.18492 15.0875 6.61507 14.736 6.2636C14.3845 5.91213 13.8147 5.91213 13.4632 6.26361L8.36321 11.3636C8.01174 11.7151 8.01174 12.285 8.36321 12.6364L13.4632 17.7364C13.8147 18.0879 14.3845 18.0879 14.736 17.7364Z"
        fill="currentColor"
      />
    </svg>
  );

export default ChevronLeftSmallIcon;
